// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  AEGWYNNS_TECHNIQUE_TALENT: {
    id: 1243507,
    name: "Aegwynn's Technique",
    icon: 'inv_misc_scrollrolled03d',
    maxRanks: 1,
    entryIds: [134020],
    definitionIds: [{ id: 138803, specId: 62 }],
  },
  AETHER_ATTUNEMENT_TALENT: {
    id: 1243307,
    name: 'Aether Attunement',
    icon: 'inv_enchant_essencearcanelarge',
    maxRanks: 2,
    entryIds: [134023],
    definitionIds: [{ id: 138806, specId: 62 }],
  },
  ALTER_TIME_TALENT: {
    id: 342245,
    name: 'Alter Time',
    icon: 'spell_mage_altertime',
    maxRanks: 1,
    entryIds: [80174],
    definitionIds: [{ id: 85177, specId: 64 }],
    manaCost: 2500,
  },
  AMPLIFICATION_TALENT: {
    id: 236628,
    name: 'Amplification',
    icon: 'spell_arcane_invocation',
    maxRanks: 1,
    entryIds: [126543],
    definitionIds: [{ id: 131369, specId: 62 }],
  },
  ARCANE_ECHO_TALENT: {
    id: 342231,
    name: 'Arcane Echo',
    icon: 'ability_socererking_arcanewrath',
    maxRanks: 1,
    entryIds: [135699],
    definitionIds: [{ id: 140454, specId: 62 }],
  },
  ARCANE_FAMILIAR_TALENT: {
    id: 205022,
    name: 'Arcane Familiar',
    icon: 'ability_socererking_arcanemines',
    maxRanks: 1,
    entryIds: [126539],
    definitionIds: [{ id: 131365, specId: 62 }],
  },
  ARCANE_MISSILES_TALENT: {
    id: 5143,
    name: 'Arcane Missiles',
    icon: 'spell_nature_starfall',
    maxRanks: 1,
    entryIds: [126537],
    definitionIds: [{ id: 131363, specId: 62 }],
    manaCost: 37500,
  },
  ARCANE_ORB_TALENT: {
    id: 153626,
    name: 'Arcane Orb',
    icon: 'spell_mage_arcaneorb',
    maxRanks: 1,
    entryIds: [128689],
    definitionIds: [{ id: 133492, specId: 62 }],
    manaCost: 2500,
  },
  ARCANE_PULSE_TALENT: {
    id: 1241462,
    name: 'Arcane Pulse',
    icon: 'spell_arcane_arcanetorrent',
    maxRanks: 1,
    entryIds: [126509],
    definitionIds: [{ id: 131335, specId: 62 }],
    manaCost: 10000,
  },
  ARCANE_SALVO_TALENT: {
    id: 384452,
    name: 'Arcane Salvo',
    icon: 'inv12_ability_mage_arcanesalvo',
    maxRanks: 1,
    entryIds: [134028],
    definitionIds: [{ id: 138811, specId: 62 }],
  },
  ARCANE_SINGULARITY_TALENT: {
    id: 1244001,
    name: 'Arcane Singularity',
    icon: 'spell_nature_wispheal',
    maxRanks: 2,
    entryIds: [134026],
    definitionIds: [{ id: 138809, specId: 62 }],
  },
  ARCANE_SURGE_TALENT: {
    id: 365350,
    name: 'Arcane Surge',
    icon: 'ability_mage_arcanesurge',
    maxRanks: 1,
    entryIds: [126519],
    definitionIds: [{ id: 131345, specId: 62 }],
    manaCost: 1,
  },
  ARCANE_TEMPO_TALENT: {
    id: 383980,
    name: 'Arcane Tempo',
    icon: 'ability_socererking_arcaneacceleration',
    maxRanks: 1,
    entryIds: [137084],
    definitionIds: [{ id: 141848, specId: 62 }],
  },
  ARCANE_WARDING_TALENT: {
    id: 383092,
    name: 'Arcane Warding',
    icon: 'spell_arcane_arcaneresilience',
    maxRanks: 2,
    entryIds: [80173],
    definitionIds: [{ id: 85176, specId: 64 }],
  },
  ARCHMAGES_WRATH_TALENT: {
    id: 444968,
    name: "Archmage's Wrath",
    icon: 'spell_arcane_arcane03',
    maxRanks: 1,
    entryIds: [117261],
    definitionIds: [{ id: 122273, specId: 64 }],
  },
  ARCING_CLEAVE_TALENT: {
    id: 231564,
    name: 'Arcing Cleave',
    icon: 'ability_mage_arcanebarrage',
    maxRanks: 1,
    entryIds: [126541],
    definitionIds: [{ id: 131367, specId: 62 }],
  },
  ASHES_OF_INSPIRATION_TALENT: {
    id: 1260272,
    name: 'Ashes of Inspiration',
    icon: 'inv_misc_powder_copper',
    maxRanks: 1,
    entryIds: [117246],
    definitionIds: [{ id: 122258, specId: 63 }],
  },
  ATTUNED_FAMILIAR_TALENT: {
    id: 1261106,
    name: 'Attuned Familiar',
    icon: 'ability_socererking_arcanemines',
    maxRanks: 1,
    entryIds: [135920],
    definitionIds: [{ id: 140675, specId: 64 }],
  },
  AUGURY_ABOUNDS_TALENT: {
    id: 1280165,
    name: 'Augury Abounds',
    icon: 'spell_arcane_arcanepotency',
    maxRanks: 1,
    entryIds: [117265],
    definitionIds: [{ id: 122277, specId: 64 }],
  },
  BARRIER_DIFFUSION_TALENT: {
    id: 455428,
    name: 'Barrier Diffusion',
    icon: 'spell_mage_evanesce',
    maxRanks: 1,
    entryIds: [80147],
    definitionIds: [{ id: 85150, specId: 64 }],
  },
  BLAST_RADIUS_TALENT: {
    id: 1248016,
    name: 'Blast Radius',
    icon: 'spell_frostresistancetotem_01',
    maxRanks: 1,
    entryIds: [117240],
    definitionIds: [{ id: 122252, specId: 64 }],
  },
  BLAST_ZONE_TALENT: {
    id: 416719,
    name: 'Blast Zone',
    icon: 'spell_fire_elementaldevastation',
    maxRanks: 1,
    entryIds: [135608],
    definitionIds: [{ id: 140364, specId: 63 }],
  },
  BLAZING_BARRIER_TALENT: {
    id: 235313,
    name: 'Blazing Barrier',
    icon: 'ability_mage_moltenarmor',
    maxRanks: 1,
    entryIds: [80178],
    definitionIds: [{ id: 85181, specId: 63 }],
    manaCost: 7500,
  },
  BLIZZARD_1_FROST_TALENT: {
    id: 190356,
    name: 'Blizzard',
    icon: 'spell_frost_icestorm',
    maxRanks: 1,
    entryIds: [134421],
    definitionIds: [{ id: 139193, specId: 64 }],
    manaCost: 6250,
  },
  BLIZZARD_2_FROST_TALENT: {
    id: 1248829,
    name: 'Blizzard',
    icon: 'spell_frost_icestorm',
    maxRanks: 1,
    entryIds: [134538],
    definitionIds: [{ id: 139306, specId: 64 }],
    manaCost: 6250,
  },
  BRAINSTORM_TALENT: {
    id: 461261,
    name: 'Brainstorm',
    icon: 'ability_kaztik_dominatemind',
    maxRanks: 1,
    entryIds: [136579],
    definitionIds: [{ id: 141352, specId: 64 }],
  },
  BRAIN_FREEZE_TALENT: {
    id: 190447,
    name: '冰冷智慧',
    icon: 'ability_mage_brainfreeze',
    maxRanks: 1,
    entryIds: [80244],
    definitionIds: [{ id: 85247, specId: 64 }],
  },
  BURDEN_OF_POWER_TALENT: {
    id: 451035,
    name: 'Burden of Power',
    icon: 'inv_ragnaros_heart',
    maxRanks: 1,
    entryIds: [117247],
    definitionIds: [{ id: 122259, specId: 63 }],
  },
  BURNOUT_TALENT: {
    id: 1271177,
    name: 'Burnout',
    icon: 'ability_mage_burnout',
    maxRanks: 1,
    entryIds: [136589],
    definitionIds: [{ id: 141362, specId: 63 }],
  },
  BURN_IT_ALL_TALENT: {
    id: 1254512,
    name: 'Burn It All',
    icon: 'ability_mage_fierypayback',
    maxRanks: 1,
    entryIds: [135618],
    definitionIds: [{ id: 140374, specId: 63 }],
  },
  CAPTURED_THOUGHTS_TALENT: {
    id: 1270872,
    name: 'Captured Thoughts',
    icon: 'spell_nature_elementalabsorption',
    maxRanks: 1,
    entryIds: [134184],
    definitionIds: [{ id: 138964, specId: 64 }],
  },
  CAUTERIZE_TALENT: {
    id: 86949,
    name: 'Cauterize',
    icon: 'spell_fire_rune',
    maxRanks: 1,
    entryIds: [135612],
    definitionIds: [{ id: 140368, specId: 63 }],
  },
  CHARGED_MISSILES_TALENT: {
    id: 461251,
    name: 'Charged Missiles',
    icon: 'ability_mage_missilebarrage',
    maxRanks: 1,
    entryIds: [134022],
    definitionIds: [{ id: 138805, specId: 62 }],
  },
  CHARGED_ORB_TALENT: {
    id: 384651,
    name: 'Charged Orb',
    icon: 'spell_mage_arcaneorb',
    maxRanks: 1,
    entryIds: [126545],
    definitionIds: [{ id: 131371, specId: 62 }],
  },
  CHARM_OF_AEGWYNN_TALENT: {
    id: 1244105,
    name: 'Charm of Aegwynn',
    icon: 'inv_nerubian_necklace_02_color5',
    maxRanks: 1,
    entryIds: [134188],
    definitionIds: [{ id: 138968, specId: 64 }],
  },
  CHARM_OF_MEDIVH_TALENT: {
    id: 1244107,
    name: 'Charm of Medivh',
    icon: 'inv_nerubian_necklace_02_color1',
    maxRanks: 1,
    entryIds: [134187],
    definitionIds: [{ id: 138967, specId: 64 }],
  },
  CINDERSTORM_TALENT: {
    id: 1254865,
    name: 'Cinderstorm',
    icon: 'spell_fire_flare',
    maxRanks: 1,
    entryIds: [135605],
    definitionIds: [{ id: 140361, specId: 63 }],
  },
  CODEX_OF_THE_SUNSTRIDERS_TALENT: {
    id: 449382,
    name: 'Codex of the Sunstriders',
    icon: 'inv_10_inscription2_book3_color1',
    maxRanks: 1,
    entryIds: [117248],
    definitionIds: [{ id: 122260, specId: 63 }],
  },
  COLD_SNAP_TALENT: {
    id: 235219,
    name: 'Cold Snap',
    icon: 'spell_frost_wizardmark',
    maxRanks: 1,
    entryIds: [134181],
    definitionIds: [{ id: 138961, specId: 64 }],
  },
  COMBUSTION_TALENT: {
    id: 190319,
    name: 'Combustion',
    icon: 'spell_fire_sealoffire',
    maxRanks: 1,
    entryIds: [124756],
    definitionIds: [{ id: 129594, specId: 63 }],
    manaCost: 25000,
  },
  COMET_STORM_TALENT: {
    id: 1247777,
    name: 'Comet Storm',
    icon: 'spell_mage_cometstorm2',
    maxRanks: 1,
    entryIds: [80251],
    definitionIds: [{ id: 85254, specId: 64 }],
  },
  CONCENTRATED_POWER_TALENT: {
    id: 414379,
    name: 'Concentrated Power',
    icon: 'spell_mage_overpowered',
    maxRanks: 1,
    entryIds: [134027],
    definitionIds: [{ id: 138810, specId: 62 }],
  },
  CONE_OF_FROST_TALENT: {
    id: 1247090,
    name: 'Cone of Frost',
    icon: 'ability_mage_chilledtothebone',
    maxRanks: 1,
    entryIds: [80239],
    definitionIds: [{ id: 85242, specId: 64 }],
  },
  CONFLAGRATION_TALENT: {
    id: 1271171,
    name: 'Conflagration',
    icon: 'spell_shaman_firenova',
    maxRanks: 1,
    entryIds: [136588],
    definitionIds: [{ id: 141361, specId: 63 }],
  },
  CONSORTIUMS_BAUBLE_TALENT: {
    id: 461260,
    name: "Consortium's Bauble",
    icon: 'inv_6_2raid_trinket_1b',
    maxRanks: 1,
    entryIds: [134024],
    definitionIds: [{ id: 138807, specId: 62 }],
  },
  CONTROLLED_DESTRUCTION_TALENT: {
    id: 383669,
    name: 'Controlled Destruction',
    icon: 'spell_fire_playingwithfire',
    maxRanks: 1,
    entryIds: [135609],
    definitionIds: [{ id: 140365, specId: 63 }],
  },
  CONTROLLED_INSTINCTS_TALENT: {
    id: 444483,
    name: 'Controlled Instincts',
    icon: 'spell_frost_ice_shards',
    maxRanks: 1,
    entryIds: [117259],
    definitionIds: [{ id: 122271, specId: 64 }],
  },
  CRITICAL_MASS_TALENT: {
    id: 117216,
    name: 'Critical Mass',
    icon: 'spell_fire_volcano',
    maxRanks: 2,
    entryIds: [124795],
    definitionIds: [{ id: 129633, specId: 63 }],
  },
  CRYSTALLINE_REFRACTION_TALENT: {
    id: 1247544,
    name: 'Crystalline Refraction',
    icon: 'inv_10_enchanting_crystal_color3',
    maxRanks: 1,
    entryIds: [136837],
    definitionIds: [{ id: 141600, specId: 64 }],
  },
  DEEP_IMPACT_TALENT: {
    id: 1254857,
    name: 'Deep Impact',
    icon: 'spell_fire_moltenblood',
    maxRanks: 1,
    entryIds: [124779],
    definitionIds: [{ id: 129617, specId: 63 }],
  },
  DEEP_SHATTER_TALENT: {
    id: 1247025,
    name: 'Deep Shatter',
    icon: 'inv_misc_frostemblem_01',
    maxRanks: 1,
    entryIds: [136796],
    definitionIds: [{ id: 141559, specId: 64 }],
  },
  DRAGONS_BREATH_TALENT: {
    id: 31661,
    name: "Dragon's Breath",
    icon: 'inv_misc_head_dragon_01',
    maxRanks: 1,
    entryIds: [125819],
    definitionIds: [{ id: 130651, specId: 64 }],
    manaCost: 10000,
  },
  DUALCASTING_ADEPT_TALENT: {
    id: 1248014,
    name: 'Dualcasting Adept',
    icon: 'ability_dualwieldspecialization',
    maxRanks: 1,
    entryIds: [117237],
    definitionIds: [{ id: 122249, specId: 64 }],
  },
  DUALITY_TALENT: {
    id: 1262843,
    name: 'Duality',
    icon: 'ability_mage_frostfirebolt',
    maxRanks: 1,
    entryIds: [135923],
    definitionIds: [{ id: 140678, specId: 64 }],
  },
  ELEMENTAL_AFFINITY_TALENT: {
    id: 431067,
    name: 'Elemental Affinity',
    icon: 'inv_10_dungeonjewelry_dragon_trinket_5_red',
    maxRanks: 1,
    entryIds: [117236],
    definitionIds: [{ id: 122248, specId: 64 }],
  },
  ELEMENTAL_CONDUIT_TALENT: {
    id: 1262845,
    name: 'Elemental Conduit',
    icon: 'inv_ability_shaman_primordialwave',
    maxRanks: 1,
    entryIds: [135921],
    definitionIds: [{ id: 140676, specId: 64 }],
  },
  ENERGIZED_BARRIERS_TALENT: {
    id: 386828,
    name: 'Energized Barriers',
    icon: 'spell_mage_temporalshield',
    maxRanks: 1,
    entryIds: [80157],
    definitionIds: [{ id: 85160, specId: 64 }],
  },
  ENERGIZED_FAMILIAR_TALENT: {
    id: 452997,
    name: 'Energized Familiar',
    icon: 'spell_lightning_lightningbolt01',
    maxRanks: 1,
    entryIds: [126511],
    definitionIds: [{ id: 131337, specId: 62 }],
  },
  ENLIGHTENED_TALENT: {
    id: 321387,
    name: 'Enlightened',
    icon: 'ability_socererking_arcanefortification',
    maxRanks: 1,
    entryIds: [126540],
    definitionIds: [{ id: 131366, specId: 62 }],
  },
  EUREKA_TALENT: {
    id: 452198,
    name: 'Eureka',
    icon: 'spell_mage_presenceofmind',
    maxRanks: 1,
    entryIds: [134196],
    definitionIds: [{ id: 138976, specId: 62 }],
  },
  EVERLASTING_FROST_TALENT: {
    id: 385167,
    name: 'Everlasting Frost',
    icon: 'spell_frost_chillingbolt',
    maxRanks: 1,
    entryIds: [102429],
    definitionIds: [{ id: 107434, specId: 64 }],
  },
  EVOCATION_TALENT: {
    id: 12051,
    name: 'Evocation',
    icon: 'spell_nature_purge',
    maxRanks: 1,
    entryIds: [126524],
    definitionIds: [{ id: 131350, specId: 62 }],
  },
  EXPANDED_MIND_TALENT: {
    id: 1243557,
    name: 'Expanded Mind',
    icon: 'inv_helmet_101',
    maxRanks: 1,
    entryIds: [134834],
    definitionIds: [{ id: 139602, specId: 62 }],
  },
  EXPLOSIVE_POTENTIAL_TALENT: {
    id: 1246030,
    name: 'Explosive Potential',
    icon: '6bf_explosive_shard',
    maxRanks: 1,
    entryIds: [134249],
    definitionIds: [{ id: 139025, specId: 63 }],
  },
  FEEL_THE_BURN_TALENT: {
    id: 383391,
    name: 'Feel the Burn',
    icon: 'spell_fire_fireball',
    maxRanks: 1,
    entryIds: [124760],
    definitionIds: [{ id: 129598, specId: 63 }],
  },
  FERVENT_FLICKERING_TALENT: {
    id: 387044,
    name: 'Fervent Flickering',
    icon: 'ability_warlock_burningembers',
    maxRanks: 1,
    entryIds: [124793],
    definitionIds: [{ id: 129631, specId: 63 }],
  },
  FEVERED_INCANTATION_TALENT: {
    id: 383810,
    name: 'Fevered Incantation',
    icon: 'inv_misc_enchantedpearld',
    maxRanks: 2,
    entryIds: [124783],
    definitionIds: [{ id: 129621, specId: 63 }],
  },
  FIERY_RUSH_TALENT: {
    id: 383634,
    name: 'Fiery Rush',
    icon: 'inv_summerfest_firespirit',
    maxRanks: 1,
    entryIds: [135604],
    definitionIds: [{ id: 140360, specId: 63 }],
  },
  FINGERS_OF_FROST_TALENT: {
    id: 112965,
    name: '寒冰指',
    icon: 'ability_mage_wintersgrasp',
    maxRanks: 1,
    entryIds: [80227],
    definitionIds: [{ id: 85230, specId: 64 }],
  },
  FIRED_UP_1_FIRE_TALENT: {
    id: 1257343,
    name: 'Fired Up',
    icon: 'inv12_apextalent_mage_firedup',
    maxRanks: 1,
    entryIds: [137037],
    definitionIds: [{ id: 141800, specId: 63 }],
  },
  FIRED_UP_2_FIRE_TALENT: {
    id: 1257349,
    name: 'Fired Up',
    icon: 'ability_warlock_backdraft',
    maxRanks: 2,
    entryIds: [137036],
    definitionIds: [{ id: 141799, specId: 63 }],
  },
  FIRED_UP_3_FIRE_TALENT: {
    id: 1257348,
    name: 'Fired Up',
    icon: 'ability_warlock_burningembers',
    maxRanks: 1,
    entryIds: [137035],
    definitionIds: [{ id: 141798, specId: 63 }],
  },
  FIRESTARTER_TALENT: {
    id: 205026,
    name: 'Firestarter',
    icon: 'spell_fire_fire',
    maxRanks: 1,
    entryIds: [136878],
    definitionIds: [{ id: 141641, specId: 63 }],
  },
  FIRES_IRE_TALENT: {
    id: 450831,
    name: "Fire's Ire",
    icon: 'achievement_boss_lordanthricyst',
    maxRanks: 2,
    entryIds: [124765],
    definitionIds: [{ id: 129603, specId: 63 }],
  },
  FIRE_BLAST_TALENT: {
    id: 108853,
    name: 'Fire Blast',
    icon: 'spell_fire_fireball',
    maxRanks: 1,
    entryIds: [124750],
    definitionIds: [{ id: 129588, specId: 63 }],
    manaCost: 2500,
  },
  FLAMESTRIKE_1_FIRE_TALENT: {
    id: 2120,
    name: 'Flamestrike',
    icon: 'spell_fire_selfdestruct',
    maxRanks: 1,
    entryIds: [135619],
    definitionIds: [{ id: 140375, specId: 63 }],
    manaCost: 3750,
  },
  FLAMESTRIKE_2_FIRE_TALENT: {
    id: 1254851,
    name: 'Flamestrike',
    icon: 'spell_fire_selfdestruct',
    maxRanks: 1,
    entryIds: [135602],
    definitionIds: [{ id: 140358, specId: 63 }],
    manaCost: 3750,
  },
  FLAME_ACCELERANT_TALENT: {
    id: 453282,
    name: 'Flame Accelerant',
    icon: 'inv_ember',
    maxRanks: 1,
    entryIds: [135601],
    definitionIds: [{ id: 140357, specId: 63 }],
  },
  FLAME_AND_FROST_TALENT: {
    id: 431112,
    name: 'Flame and Frost',
    icon: 'spell_firefrost_orb',
    maxRanks: 1,
    entryIds: [117775],
    definitionIds: [{ id: 122787, specId: 64 }],
  },
  FLAME_ON_TALENT: {
    id: 205029,
    name: 'Flame On',
    icon: 'inv_helm_circlet_firelands_d_01',
    maxRanks: 1,
    entryIds: [124771],
    definitionIds: [{ id: 129609, specId: 63 }],
  },
  FLASH_FREEZEBURN_TALENT: {
    id: 431178,
    name: 'Flash Freezeburn',
    icon: 'spell_fire_elementaldevastation',
    maxRanks: 1,
    entryIds: [117235],
    definitionIds: [{ id: 122247, specId: 64 }],
  },
  FLASH_FREEZE_TALENT: {
    id: 379993,
    name: 'Flash Freeze',
    icon: 'spell_hunter_icetrap',
    maxRanks: 1,
    entryIds: [134407],
    definitionIds: [{ id: 139179, specId: 64 }],
  },
  FLOW_OF_TIME_TALENT: {
    id: 382268,
    name: 'Flow of Time',
    icon: 'spell_arcane_blink',
    maxRanks: 1,
    entryIds: [80153],
    definitionIds: [{ id: 85156, specId: 64 }],
  },
  FLURRY_TALENT: {
    id: 44614,
    name: '冰风暴',
    icon: 'ability_deathknight_chillstreak',
    maxRanks: 1,
    entryIds: [80243],
    definitionIds: [{ id: 85246, specId: 64 }],
    manaCost: 2500,
  },
  FOCUSING_CRYSTAL_TALENT: {
    id: 461257,
    name: 'Focusing Crystal',
    icon: 'ability_racial_arcaneaffinity',
    maxRanks: 1,
    entryIds: [126521],
    definitionIds: [{ id: 131347, specId: 62 }],
  },
  FORCE_OF_WILL_TALENT: {
    id: 444719,
    name: 'Force of Will',
    icon: 'spell_mage_overpowered',
    maxRanks: 1,
    entryIds: [117266],
    definitionIds: [{ id: 122278, specId: 64 }],
  },
  FRACTURED_FROST_TALENT: {
    id: 378448,
    name: 'Fractured Frost',
    icon: 'spell_fire_frostresistancetotem',
    maxRanks: 1,
    entryIds: [80214],
    definitionIds: [{ id: 85217, specId: 64 }],
  },
  FREEZING_COLD_TALENT: {
    id: 386763,
    name: 'Freezing Cold',
    icon: 'spell_frost_glacier',
    maxRanks: 1,
    entryIds: [80143],
    definitionIds: [{ id: 85146, specId: 64 }],
  },
  FREEZING_RAIN_TALENT: {
    id: 270233,
    name: 'Freezing Rain',
    icon: 'spell_frost_frozenorb',
    maxRanks: 1,
    entryIds: [134416],
    definitionIds: [{ id: 139188, specId: 64 }],
  },
  FREEZING_WINDS_TALENT: {
    id: 1216953,
    name: 'Freezing Winds',
    icon: 'spell_fire_blueflamering',
    maxRanks: 1,
    entryIds: [134409],
    definitionIds: [{ id: 139181, specId: 64 }],
  },
  FRIGID_FOCUS_TALENT: {
    id: 1247055,
    name: 'Frigid Focus',
    icon: 'ability_deathknight_shroudofwinter',
    maxRanks: 1,
    entryIds: [134418],
    definitionIds: [{ id: 139190, specId: 64 }],
  },
  FROM_THE_ASHES_TALENT: {
    id: 342344,
    name: 'From the Ashes',
    icon: 'inv_misc_phoenixegg',
    maxRanks: 1,
    entryIds: [135600],
    definitionIds: [{ id: 140356, specId: 63 }],
  },
  FROSTBITE_TALENT: {
    id: 1248825,
    name: 'Frostbite',
    icon: 'spell_frost_frostarmor',
    maxRanks: 1,
    entryIds: [80220],
    definitionIds: [{ id: 85223, specId: 64 }],
  },
  FROSTFIRE_BOLT_TALENT: {
    id: 431044,
    name: 'Frostfire Bolt',
    icon: 'inv_ability_frostfiremage_frostfirebolt',
    maxRanks: 1,
    entryIds: [136441, 117239],
    definitionIds: [
      { id: 141214, specId: 63 },
      { id: 122251, specId: 64 },
    ],
    manaCost: 5000,
  },
  FROSTFIRE_EMPOWERMENT_TALENT: {
    id: 431176,
    name: 'Frostfire Empowerment',
    icon: 'spell_frostfire_orb',
    maxRanks: 1,
    entryIds: [117244],
    definitionIds: [{ id: 122256, specId: 64 }],
  },
  FROSTFIRE_INFUSION_TALENT: {
    id: 431166,
    name: 'Frostfire Infusion',
    icon: 'inv_10_blacksmithing_craftedbar_frostfirealloy',
    maxRanks: 1,
    entryIds: [117242],
    definitionIds: [{ id: 122254, specId: 64 }],
  },
  FROST_CONDITIONING_TALENT: {
    id: 1250315,
    name: 'Frost Conditioning',
    icon: 'spell_frost_icefloes',
    maxRanks: 1,
    entryIds: [80165],
    definitionIds: [{ id: 85168, specId: 64 }],
  },
  FROZEN_ORB_TALENT: {
    id: 84714,
    name: 'Frozen Orb',
    icon: 'spell_frost_frozenorb',
    maxRanks: 1,
    entryIds: [80242],
    definitionIds: [{ id: 85245, specId: 64 }],
    manaCost: 2500,
  },
  FROZEN_TOUCH_TALENT: {
    id: 205030,
    name: 'Frozen Touch',
    icon: 'ability_mage_burstofcold',
    maxRanks: 1,
    entryIds: [80245],
    definitionIds: [{ id: 85248, specId: 64 }],
  },
  FUEL_THE_FIRE_TALENT: {
    id: 416094,
    name: 'Fuel the Fire',
    icon: 'ability_warlock_inferno',
    maxRanks: 1,
    entryIds: [135615],
    definitionIds: [{ id: 140371, specId: 63 }],
  },
  GLACIAL_ASSAULT_TALENT: {
    id: 378947,
    name: 'Glacial Assault',
    icon: 'inv_staff_15',
    maxRanks: 1,
    entryIds: [134405],
    definitionIds: [{ id: 139177, specId: 64 }],
  },
  GLACIAL_ATTUNEMENT_TALENT: {
    id: 1247759,
    name: 'Glacial Attunement',
    icon: 'ability_hunter_glacialtrap',
    maxRanks: 2,
    entryIds: [134414],
    definitionIds: [{ id: 139186, specId: 64 }],
  },
  GLACIAL_BULWARK_TALENT: {
    id: 1244110,
    name: 'Glacial Bulwark',
    icon: 'spell_frost_chillingarmor',
    maxRanks: 1,
    entryIds: [134180],
    definitionIds: [{ id: 138960, specId: 64 }],
  },
  GLACIAL_CHILL_TALENT: {
    id: 1280779,
    name: 'Glacial Chill',
    icon: 'spell_frost_iceshard',
    maxRanks: 1,
    entryIds: [134420],
    definitionIds: [{ id: 139192, specId: 64 }],
  },
  GLACIAL_SHATTER_TALENT: {
    id: 1280780,
    name: 'Glacial Shatter',
    icon: 'artifactability_frostmage_ebonbolt',
    maxRanks: 1,
    entryIds: [136838],
    definitionIds: [{ id: 141601, specId: 64 }],
  },
  GLACIATE_TALENT: {
    id: 1247798,
    name: 'Glaciate',
    icon: 'spell_frost_frozencore',
    maxRanks: 1,
    entryIds: [80250],
    definitionIds: [{ id: 85253, specId: 64 }],
  },
  GLORIOUS_INCANDESCENCE_TALENT: {
    id: 449394,
    name: 'Glorious Incandescence',
    icon: 'spell_burningsoul',
    maxRanks: 1,
    entryIds: [135926],
    definitionIds: [{ id: 140681, specId: 63 }],
  },
  GREATER_INVISIBILITY_TALENT: {
    id: 110959,
    name: 'Greater Invisibility',
    icon: 'ability_mage_greaterinvisibility',
    maxRanks: 1,
    entryIds: [115877],
    definitionIds: [{ id: 120889, specId: 64 }],
  },
  HAILSTONES_TALENT: {
    id: 1247742,
    name: 'Hailstones',
    icon: 'artifactability_frostmage_blackicicles',
    maxRanks: 1,
    entryIds: [134413],
    definitionIds: [{ id: 139185, specId: 64 }],
  },
  HAND_OF_FROST_1_FROST_TALENT: {
    id: 1262935,
    name: 'Hand of Frost',
    icon: 'inv12_apextalent_mage_handoffrost',
    maxRanks: 1,
    entryIds: [137034],
    definitionIds: [{ id: 141797, specId: 64 }],
  },
  HAND_OF_FROST_2_FROST_TALENT: {
    id: 1262981,
    name: 'Hand of Frost',
    icon: 'spell_frost_piercing_chill',
    maxRanks: 2,
    entryIds: [137033],
    definitionIds: [{ id: 141796, specId: 64 }],
  },
  HAND_OF_FROST_3_FROST_TALENT: {
    id: 1263249,
    name: 'Hand of Frost',
    icon: 'ability_mage_rayoffrost',
    maxRanks: 1,
    entryIds: [137032],
    definitionIds: [{ id: 141795, specId: 64 }],
  },
  HEART_OF_ICE_TALENT: {
    id: 1247799,
    name: 'Heart of Ice',
    icon: 'inv_10_dungeonjewelry_primalist_necklace_1_frost',
    maxRanks: 1,
    entryIds: [136183],
    definitionIds: [{ id: 140956, specId: 64 }],
  },
  HEAT_SHIMMER_TALENT: {
    id: 457735,
    name: 'Heat Shimmer',
    icon: 'ability_rhyolith_magmaflow_wave',
    maxRanks: 1,
    entryIds: [135621],
    definitionIds: [{ id: 140377, specId: 63 }],
  },
  HEAT_SINK_TALENT: {
    id: 1248002,
    name: 'Heat Sink',
    icon: 'spell_fire_masterofelements',
    maxRanks: 1,
    entryIds: [117241],
    definitionIds: [{ id: 122253, specId: 64 }],
  },
  HIGH_VOLTAGE_TALENT: {
    id: 461248,
    name: 'High Voltage',
    icon: 'spell_shaman_maelstromweapon',
    maxRanks: 1,
    entryIds: [126542],
    definitionIds: [{ id: 131368, specId: 62 }],
  },
  ICE_BARRIER_TALENT: {
    id: 11426,
    name: 'Ice Barrier',
    icon: 'spell_ice_lament',
    maxRanks: 1,
    entryIds: [80176],
    definitionIds: [{ id: 85179, specId: 64 }],
    manaCost: 7500,
  },
  ICE_BLOCK_TALENT: {
    id: 45438,
    name: '寒冰屏障',
    icon: 'spell_frost_frost',
    maxRanks: 1,
    entryIds: [80181],
    definitionIds: [{ id: 85184, specId: 64 }],
  },
  ICE_COLD_TALENT: {
    id: 414659,
    name: '冰冷血脉',
    icon: 'spell_fire_bluefire',
    maxRanks: 1,
    entryIds: [80141],
    definitionIds: [{ id: 85144, specId: 64 }],
  },
  ICE_LANCE_TALENT: {
    id: 30455,
    name: '冰枪术',
    icon: 'spell_frost_frostblast',
    maxRanks: 1,
    entryIds: [80241],
    definitionIds: [{ id: 85244, specId: 64 }],
    manaCost: 2500,
  },
  ICE_NOVA_TALENT: {
    id: 157997,
    name: 'Ice Nova',
    icon: 'spell_mage_icenova',
    maxRanks: 1,
    entryIds: [134199],
    definitionIds: [{ id: 138979, specId: 64 }],
  },
  ICE_WARD_TALENT: {
    id: 205036,
    name: 'Ice Ward',
    icon: 'spell_frost_frostward',
    maxRanks: 1,
    entryIds: [136466],
    definitionIds: [{ id: 141239, specId: 64 }],
  },
  ICICLES_TALENT: {
    id: 1246832,
    name: 'Icicles',
    icon: 'ability_mage_glacialspike',
    maxRanks: 1,
    entryIds: [136182],
    definitionIds: [{ id: 140955, specId: 64 }],
  },
  IGNITION_TALENT: {
    id: 1254756,
    name: 'Ignition',
    icon: 'item_sparkofragnoros',
    maxRanks: 1,
    entryIds: [135616],
    definitionIds: [{ id: 140372, specId: 63 }],
  },
  ILLUMINATED_THOUGHTS_TALENT: {
    id: 384060,
    name: 'Illuminated Thoughts',
    icon: 'spell_arcane_focusedpower',
    maxRanks: 1,
    entryIds: [134047],
    definitionIds: [{ id: 138830, specId: 62 }],
  },
  IMBUED_WARDING_TALENT: {
    id: 431066,
    name: 'Imbued Warding',
    icon: 'inv_10_jewelcrafting_gem3primal_fire_cut_blue',
    maxRanks: 1,
    entryIds: [117245],
    definitionIds: [{ id: 122257, specId: 64 }],
  },
  IMPETUS_TALENT: {
    id: 383676,
    name: 'Impetus',
    icon: 'spell_arcane_arcanetorrent',
    maxRanks: 1,
    entryIds: [126523],
    definitionIds: [{ id: 131349, specId: 62 }],
  },
  IMPROVED_BLAZING_BARRIER_TALENT: {
    id: 321708,
    name: 'Improved Blazing Barrier',
    icon: 'ability_mage_moltenarmor',
    maxRanks: 1,
    entryIds: [134186],
    definitionIds: [{ id: 138966, specId: 63 }],
  },
  IMPROVED_BLINK_TALENT: {
    id: 1244340,
    name: 'Improved Blink',
    icon: 'spell_arcane_blink',
    maxRanks: 1,
    entryIds: [134197],
    definitionIds: [{ id: 138977, specId: 64 }],
  },
  IMPROVED_CLEARCASTING_TALENT: {
    id: 321420,
    name: 'Improved Clearcasting',
    icon: 'spell_shadow_manaburn',
    maxRanks: 1,
    entryIds: [126515],
    definitionIds: [{ id: 131341, specId: 62 }],
  },
  IMPROVED_CONJURATION_TALENT: {
    id: 1244025,
    name: 'Improved Conjuration',
    icon: 'spell_arcane_focusedpower',
    maxRanks: 2,
    entryIds: [134192],
    definitionIds: [{ id: 138972, specId: 64 }],
  },
  IMPROVED_COUNTERSPELL_TALENT: {
    id: 1270865,
    name: 'Improved Counterspell',
    icon: 'inv_1115_mage_counterspell',
    maxRanks: 1,
    entryIds: [136577],
    definitionIds: [{ id: 141350, specId: 64 }],
  },
  IMPROVED_FLURRY_TALENT: {
    id: 1247769,
    name: 'Improved Flurry',
    icon: 'ability_warlock_burningembersblue',
    maxRanks: 1,
    entryIds: [134411],
    definitionIds: [{ id: 139183, specId: 64 }],
  },
  IMPROVED_FROST_NOVA_TALENT: {
    id: 343183,
    name: 'Improved Frost Nova',
    icon: 'spell_frost_frostnova',
    maxRanks: 1,
    entryIds: [80168],
    definitionIds: [{ id: 85171, specId: 64 }],
  },
  IMPROVED_ICE_BARRIER_TALENT: {
    id: 1244069,
    name: 'Improved Ice Barrier',
    icon: 'spell_ice_lament',
    maxRanks: 1,
    entryIds: [134185],
    definitionIds: [{ id: 138965, specId: 64 }],
  },
  IMPROVED_PRISMATIC_BARRIER_TALENT: {
    id: 321745,
    name: 'Improved Prismatic Barrier',
    icon: 'spell_magearmor',
    maxRanks: 1,
    entryIds: [134194],
    definitionIds: [{ id: 138974, specId: 62 }],
  },
  IMPROVED_REMOVE_CURSE_TALENT: {
    id: 1270847,
    name: 'Improved Remove Curse',
    icon: 'spell_nature_removecurse',
    maxRanks: 1,
    entryIds: [136576],
    definitionIds: [{ id: 141349, specId: 64 }],
  },
  IMPROVED_SHATTER_TALENT: {
    id: 1246811,
    name: 'Improved Shatter',
    icon: 'spell_frost_frostshock',
    maxRanks: 1,
    entryIds: [134415],
    definitionIds: [{ id: 139187, specId: 64 }],
  },
  IMPROVED_SPELLSTEAL_TALENT: {
    id: 1270827,
    name: 'Improved Spellsteal',
    icon: 'spell_arcane_arcane02',
    maxRanks: 1,
    entryIds: [136581],
    definitionIds: [{ id: 141354, specId: 64 }],
  },
  INCANTATION_OF_SWIFTNESS_TALENT: {
    id: 382293,
    name: 'Incantation of Swiftness',
    icon: 'rogue_burstofspeed',
    maxRanks: 2,
    entryIds: [80170],
    definitionIds: [{ id: 85173, specId: 64 }],
  },
  INFLAME_TALENT: {
    id: 417467,
    name: 'Inflame',
    icon: 'spell_fire_ragnaros_lavabolt',
    maxRanks: 1,
    entryIds: [136587],
    definitionIds: [{ id: 141360, specId: 63 }],
  },
  INFUSED_SPLINTERS_TALENT: {
    id: 1261080,
    name: 'Infused Splinters',
    icon: 'spell_mage_focusingcrystal',
    maxRanks: 1,
    entryIds: [135919],
    definitionIds: [{ id: 140674, specId: 64 }],
  },
  INSPIRED_INTELLECT_TALENT: {
    id: 458437,
    name: 'Inspired Intellect',
    icon: 'spell_holy_arcaneintellect',
    maxRanks: 1,
    entryIds: [134190],
    definitionIds: [{ id: 138970, specId: 64 }],
  },
  INTENSIFYING_FLAME_TALENT: {
    id: 416714,
    name: 'Intensifying Flame',
    icon: 'spell_fire_incinerate',
    maxRanks: 1,
    entryIds: [135610],
    definitionIds: [{ id: 140366, specId: 63 }],
  },
  INTUITION_TALENT: {
    id: 1223798,
    name: 'Intuition',
    icon: 'spell_shadow_brainwash',
    maxRanks: 1,
    entryIds: [126516],
    definitionIds: [{ id: 131342, specId: 62 }],
  },
  INVOCATION_ARCANE_PHOENIX_TALENT: {
    id: 448658,
    name: 'Invocation: Arcane Phoenix',
    icon: 'inv_misc_phoenixegg',
    maxRanks: 1,
    entryIds: [117255],
    definitionIds: [{ id: 122267, specId: 63 }],
  },
  ISOTHERMIC_CORE_TALENT: {
    id: 431095,
    name: 'Isothermic Core',
    icon: 'inv12_ability_mage_isothermiccore',
    maxRanks: 1,
    entryIds: [117238],
    definitionIds: [{ id: 122250, specId: 64 }],
  },
  KINDLING_TALENT: {
    id: 1254194,
    name: 'Kindling',
    icon: 'spell_mage_kindling',
    maxRanks: 1,
    entryIds: [124789],
    definitionIds: [{ id: 129627, specId: 63 }],
  },
  LESSONS_IN_DEBILITATION_TALENT: {
    id: 449627,
    name: 'Lessons in Debilitation',
    icon: 'ability_paladin_handoflight',
    maxRanks: 1,
    entryIds: [117254],
    definitionIds: [{ id: 122266, specId: 63 }],
  },
  LONELY_WINTER_TALENT: {
    id: 205024,
    name: 'Lonely Winter',
    icon: 'achievement_dungeon_frozenthrone',
    maxRanks: 1,
    entryIds: [136839],
    definitionIds: [{ id: 141602, specId: 64 }],
  },
  LOOK_AGAIN_TALENT: {
    id: 444756,
    name: 'Look Again',
    icon: 'achievement_bg_tophealer_av',
    maxRanks: 1,
    entryIds: [123418],
    definitionIds: [{ id: 128256, specId: 64 }],
  },
  MANA_ADEPT_TALENT: {
    id: 321526,
    name: 'Mana Adept',
    icon: 'spell_arcane_arcanepotency',
    maxRanks: 1,
    entryIds: [136465],
    definitionIds: [{ id: 141238, specId: 62 }],
  },
  MANA_BOMB_TALENT: {
    id: 457521,
    name: 'Mana Bomb',
    icon: 'spell_holy_surgeoflight_shadow',
    maxRanks: 1,
    entryIds: [126510],
    definitionIds: [{ id: 131336, specId: 62 }],
  },
  MANA_CASCADE_TALENT: {
    id: 449293,
    name: 'Mana Cascade',
    icon: 'spell_frost_manarecharge',
    maxRanks: 1,
    entryIds: [117256],
    definitionIds: [{ id: 122268, specId: 63 }],
  },
  MANA_CONFLUENCE_TALENT: {
    id: 1270845,
    name: 'Mana Confluence',
    icon: 'spell_shaman_blessingoftheeternals',
    maxRanks: 1,
    entryIds: [136578],
    definitionIds: [{ id: 141351, specId: 64 }],
  },
  MASS_INVISIBILITY_TALENT: {
    id: 414664,
    name: 'Mass Invisibility',
    icon: 'ability_mage_massinvisibility',
    maxRanks: 1,
    entryIds: [115878],
    definitionIds: [{ id: 120890, specId: 64 }],
    manaCost: 15000,
  },
  MASS_POLYMORPH_TALENT: {
    id: 383121,
    name: 'Mass Polymorph',
    icon: 'spell_nature_doublepolymorph1',
    maxRanks: 1,
    entryIds: [134198],
    definitionIds: [{ id: 138978, specId: 64 }],
    manaCost: 10000,
  },
  MASTER_OF_ESCAPE_TALENT: {
    id: 210476,
    name: 'Master of Escape',
    icon: 'ability_mage_invisibility',
    maxRanks: 1,
    entryIds: [134189],
    definitionIds: [{ id: 138969, specId: 64 }],
  },
  MASTER_OF_FLAME_TALENT: {
    id: 384174,
    name: 'Master of Flame',
    icon: 'inv_trinket_firelands_02',
    maxRanks: 1,
    entryIds: [135603],
    definitionIds: [{ id: 140359, specId: 63 }],
  },
  MASTER_OF_TIME_TALENT: {
    id: 342249,
    name: 'Master of Time',
    icon: 'inv_belt_armor_waistoftime_d_01',
    maxRanks: 2,
    entryIds: [80159],
    definitionIds: [{ id: 85162, specId: 64 }],
  },
  MELTDOWN_TALENT: {
    id: 431131,
    name: 'Meltdown',
    icon: 'spell_frost_arcticwinds',
    maxRanks: 1,
    entryIds: [117776],
    definitionIds: [{ id: 122788, specId: 64 }],
  },
  MEMORY_OF_ALAR_TALENT: {
    id: 449619,
    name: "Memory of Al'ar",
    icon: 'inv_ability_sunfurymage_spellfirespheres',
    maxRanks: 1,
    entryIds: [117249],
    definitionIds: [{ id: 122261, specId: 63 }],
  },
  MERELY_A_SETBACK_TALENT: {
    id: 449330,
    name: 'Merely a Setback',
    icon: 'inv_helm_robe_raidmage_i_01',
    maxRanks: 1,
    entryIds: [117252],
    definitionIds: [{ id: 122264, specId: 63 }],
  },
  METEOR_TALENT: {
    id: 153561,
    name: 'Meteor',
    icon: 'spell_mage_meteor',
    maxRanks: 1,
    entryIds: [124786],
    definitionIds: [{ id: 129624, specId: 63 }],
    manaCost: 2500,
  },
  MIRROR_IMAGE_TALENT: {
    id: 55342,
    name: 'Mirror Image',
    icon: 'spell_magic_lesserinvisibilty',
    maxRanks: 1,
    entryIds: [80183],
    definitionIds: [{ id: 85186, specId: 64 }],
    manaCost: 5000,
  },
  MOLTEN_CHILL_TALENT: {
    id: 1262844,
    name: 'Molten Chill',
    icon: 'spell_fire_incinerate',
    maxRanks: 1,
    entryIds: [135922],
    definitionIds: [{ id: 140677, specId: 64 }],
  },
  MOLTEN_FURY_TALENT: {
    id: 457803,
    name: 'Molten Fury',
    icon: 'warrior_talent_icon_furyintheblood',
    maxRanks: 1,
    entryIds: [135606],
    definitionIds: [{ id: 140362, specId: 63 }],
  },
  MOTE_OF_FLAME_TALENT: {
    id: 343230,
    name: 'Mote of Flame',
    icon: 'inv_10_elementalcombinedfoozles_fire',
    maxRanks: 1,
    entryIds: [135607],
    definitionIds: [{ id: 140363, specId: 63 }],
  },
  ORB_BARRAGE_TALENT: {
    id: 384858,
    name: 'Orb Barrage',
    icon: 'spell_mage_arcaneorb_nightborne',
    maxRanks: 1,
    entryIds: [126544],
    definitionIds: [{ id: 131370, specId: 62 }],
  },
  ORB_MASTERY_TALENT: {
    id: 1243435,
    name: 'Orb Mastery',
    icon: 'ability_evoker_powerswell',
    maxRanks: 1,
    entryIds: [126508],
    definitionIds: [{ id: 131334, specId: 62 }],
  },
  OVERFLOWING_ENERGY_TALENT: {
    id: 390218,
    name: 'Overflowing Energy',
    icon: 'spell_arcane_manatap',
    maxRanks: 1,
    entryIds: [134191],
    definitionIds: [{ id: 138971, specId: 64 }],
  },
  OVERFLOWING_INSIGHT_TALENT: {
    id: 1243542,
    name: 'Overflowing Insight',
    icon: 'inv_offhand_pvealliance_d_01',
    maxRanks: 1,
    entryIds: [126546],
    definitionIds: [{ id: 131372, specId: 62 }],
  },
  OVERPOWERED_MISSILES_TALENT: {
    id: 1244329,
    name: 'Overpowered Missiles',
    icon: 'ability_socererking_arcanereplication',
    maxRanks: 1,
    entryIds: [135698],
    definitionIds: [{ id: 140453, specId: 62 }],
  },
  PERMAFROST_BAUBLE_TALENT: {
    id: 1265517,
    name: 'Permafrost Bauble',
    icon: 'inv_10_dungeonjewelry_primalist_necklace_2_frost',
    maxRanks: 1,
    entryIds: [80142],
    definitionIds: [{ id: 85145, specId: 64 }],
  },
  PERMAFROST_LANCES_TALENT: {
    id: 460590,
    name: 'Permafrost Lances',
    icon: 'spell_fire_bluerainoffire',
    maxRanks: 1,
    entryIds: [80234],
    definitionIds: [{ id: 85237, specId: 64 }],
  },
  PHANTASMAL_IMAGE_TALENT: {
    id: 444784,
    name: 'Phantasmal Image',
    icon: 'spell_arcane_prismaticcloak',
    maxRanks: 1,
    entryIds: [123417],
    definitionIds: [{ id: 128255, specId: 64 }],
  },
  PIERCING_COLD_TALENT: {
    id: 378919,
    name: 'Piercing Cold',
    icon: 'spell_frost_frostbolt',
    maxRanks: 1,
    entryIds: [80247],
    definitionIds: [{ id: 85250, specId: 64 }],
  },
  POLISHED_FOCUS_TALENT: {
    id: 1261082,
    name: 'Polished Focus',
    icon: 'inv_misc_orb_blue',
    maxRanks: 1,
    entryIds: [135918],
    definitionIds: [{ id: 140673, specId: 64 }],
  },
  PRESENCE_OF_MIND_TALENT: {
    id: 205025,
    name: 'Presence of Mind',
    icon: 'spell_nature_enchantarmor',
    maxRanks: 1,
    entryIds: [126530],
    definitionIds: [{ id: 131356, specId: 62 }],
  },
  PRISMATIC_BARRIER_TALENT: {
    id: 235450,
    name: 'Prismatic Barrier',
    icon: 'spell_magearmor',
    maxRanks: 1,
    entryIds: [80180],
    definitionIds: [{ id: 85183, specId: 62 }],
    manaCost: 7500,
  },
  PRODIGIOUS_SAVANT_TALENT: {
    id: 384612,
    name: 'Prodigious Savant',
    icon: 'ability_mage_studentofthemind',
    maxRanks: 2,
    entryIds: [126550],
    definitionIds: [{ id: 131376, specId: 62 }],
  },
  PYROBLAST_TALENT: {
    id: 11366,
    name: 'Pyroblast',
    icon: 'spell_fire_fireball02',
    maxRanks: 1,
    entryIds: [124759],
    definitionIds: [{ id: 129597, specId: 63 }],
    manaCost: 3750,
  },
  PYROCLASM_TALENT: {
    id: 269650,
    name: 'Pyroclasm',
    icon: 'spell_shaman_lavasurge',
    maxRanks: 1,
    entryIds: [124778],
    definitionIds: [{ id: 129616, specId: 63 }],
  },
  PYROCOSM_TALENT: {
    id: 1260673,
    name: 'Pyrocosm',
    icon: 'spell_fire_meteorstorm',
    maxRanks: 1,
    entryIds: [135925],
    definitionIds: [{ id: 140680, specId: 63 }],
  },
  PYROMANIAC_TALENT: {
    id: 451466,
    name: 'Pyromaniac',
    icon: 'inv_misc_volatilefire',
    maxRanks: 1,
    entryIds: [136590],
    definitionIds: [{ id: 141363, specId: 63 }],
  },
  QUICK_WITTED_TALENT: {
    id: 382297,
    name: 'Quick Witted',
    icon: 'ability_priest_surgeofdarkness',
    maxRanks: 1,
    entryIds: [80161],
    definitionIds: [{ id: 85164, specId: 64 }],
  },
  RAY_OF_FROST_TALENT: {
    id: 205021,
    name: '冰霜射线',
    icon: 'ability_mage_rayoffrost',
    maxRanks: 1,
    entryIds: [80216],
    definitionIds: [{ id: 85219, specId: 64 }],
    manaCost: 5000,
  },
  REACTIVE_BARRIER_TALENT: {
    id: 444827,
    name: 'Reactive Barrier',
    icon: 'ability_racial_forceshield',
    maxRanks: 1,
    entryIds: [117263],
    definitionIds: [{ id: 122275, specId: 64 }],
  },
  REFLECTION_TALENT: {
    id: 1270829,
    name: 'Reflection',
    icon: 'ability_hunter_displacement',
    maxRanks: 1,
    entryIds: [136580],
    definitionIds: [{ id: 141353, specId: 64 }],
  },
  REMOVE_CURSE_TALENT: {
    id: 475,
    name: 'Remove Curse',
    icon: 'spell_nature_removecurse',
    maxRanks: 1,
    entryIds: [80175],
    definitionIds: [{ id: 85178, specId: 64 }],
    manaCost: 3250,
  },
  RESONANCE_TALENT: {
    id: 205028,
    name: 'Resonance',
    icon: 'spell_arcane_arcane01',
    maxRanks: 1,
    entryIds: [134030],
    definitionIds: [{ id: 138813, specId: 62 }],
  },
  REVERBERATE_TALENT: {
    id: 281482,
    name: 'Reverberate',
    icon: 'spell_arcane_arcane04',
    maxRanks: 1,
    entryIds: [126532],
    definitionIds: [{ id: 131358, specId: 62 }],
  },
  RIMECASTER_TALENT: {
    id: 1247743,
    name: 'Rimecaster',
    icon: 'spell_frost_manarecharge',
    maxRanks: 2,
    entryIds: [134408],
    definitionIds: [{ id: 139180, specId: 64 }],
  },
  RING_OF_FROST_TALENT: {
    id: 113724,
    name: 'Ring of Frost',
    icon: 'spell_frost_ring_of_frost',
    maxRanks: 1,
    entryIds: [80144],
    definitionIds: [{ id: 85147, specId: 64 }],
    manaCost: 20000,
  },
  RONDURMANCY_TALENT: {
    id: 449596,
    name: 'Rondurmancy',
    icon: 'spell_arcane_focusedpower',
    maxRanks: 1,
    entryIds: [117251],
    definitionIds: [{ id: 122263, specId: 63 }],
  },
  SAVOR_THE_MOMENT_TALENT: {
    id: 449412,
    name: 'Savor the Moment',
    icon: 'spell_fire_masterofelements',
    maxRanks: 1,
    entryIds: [117253],
    definitionIds: [{ id: 122265, specId: 63 }],
  },
  SCALD_TALENT: {
    id: 450746,
    name: 'Scald',
    icon: 'ability_racial_foregedinflames',
    maxRanks: 1,
    entryIds: [135617],
    definitionIds: [{ id: 140373, specId: 63 }],
  },
  SCORCH_TALENT: {
    id: 2948,
    name: 'Scorch',
    icon: 'spell_fire_soulburn',
    maxRanks: 1,
    entryIds: [136879],
    definitionIds: [{ id: 141642, specId: 63 }],
    manaCost: 2500,
  },
  SEVERE_TEMPERATURES_TALENT: {
    id: 431189,
    name: 'Severe Temperatures',
    icon: 'inv_magemount_fire',
    maxRanks: 1,
    entryIds: [134441],
    definitionIds: [{ id: 139212, specId: 64 }],
  },
  SHIFTING_SHARDS_TALENT: {
    id: 444675,
    name: 'Shifting Shards',
    icon: 'ability_mage_freeze',
    maxRanks: 1,
    entryIds: [135946],
    definitionIds: [{ id: 140701, specId: 64 }],
  },
  SHIMMER_TALENT: {
    id: 212653,
    name: '闪烁',
    icon: 'spell_arcane_massdispel',
    maxRanks: 1,
    entryIds: [80163],
    definitionIds: [{ id: 85166, specId: 64 }],
    manaCost: 5000,
  },
  SIGNATURE_SPELL_TALENT: {
    id: 470021,
    name: 'Signature Spell',
    icon: 'inv_enchanting_815_drustwand',
    maxRanks: 1,
    entryIds: [128267],
    definitionIds: [{ id: 133074, specId: 64 }],
  },
  SLIPPERY_SLINGING_TALENT: {
    id: 444752,
    name: 'Slippery Slinging',
    icon: 'ability_mage_icyfeet',
    maxRanks: 1,
    entryIds: [117262],
    definitionIds: [{ id: 122274, specId: 64 }],
  },
  SLIPSTREAM_TALENT: {
    id: 236457,
    name: 'Slipstream',
    icon: 'spell_holy_mindsooth',
    maxRanks: 1,
    entryIds: [134025],
    definitionIds: [{ id: 138808, specId: 62 }],
  },
  SLOW_BURN_TALENT: {
    id: 383967,
    name: 'Slow Burn',
    icon: 'spell_fire_sealoffire',
    maxRanks: 1,
    entryIds: [124769],
    definitionIds: [{ id: 129607, specId: 63 }],
  },
  SPATIAL_MANIPULATION_TALENT: {
    id: 1244031,
    name: 'Spatial Manipulation',
    icon: 'spell_mage_overpowered',
    maxRanks: 1,
    entryIds: [126060],
    definitionIds: [{ id: 130892, specId: 64 }],
  },
  SPELLFIRE_SALVO_TALENT: {
    id: 1260616,
    name: 'Spellfire Salvo',
    icon: 'shaman_talent_elementalblast',
    maxRanks: 1,
    entryIds: [135924],
    definitionIds: [{ id: 140679, specId: 63 }],
  },
  SPELLFIRE_SPHERES_TALENT: {
    id: 448601,
    name: 'Spellfire Spheres',
    icon: 'inv_1115_mage_spellfirespheresgeneration',
    maxRanks: 1,
    entryIds: [117250],
    definitionIds: [{ id: 122262, specId: 63 }],
  },
  SPELLFROST_TEACHINGS_TALENT: {
    id: 444986,
    name: 'Spellfrost Teachings',
    icon: '70_inscription_vantus_rune_azure',
    maxRanks: 1,
    entryIds: [117258],
    definitionIds: [{ id: 122270, specId: 64 }],
  },
  SPELLSTEAL_TALENT: {
    id: 30449,
    name: 'Spellsteal',
    icon: 'spell_arcane_arcane02',
    maxRanks: 1,
    entryIds: [80140],
    definitionIds: [{ id: 85143, specId: 64 }],
    manaCost: 52500,
  },
  SPLINTERING_ORBS_TALENT: {
    id: 444256,
    name: 'Splintering Orbs',
    icon: 'item_azereansphere',
    maxRanks: 1,
    entryIds: [117264],
    definitionIds: [{ id: 122276, specId: 64 }],
  },
  SPLINTERING_RAY_TALENT: {
    id: 418733,
    name: 'Splintering Ray',
    icon: 'spell_fire_blueflamestrike',
    maxRanks: 1,
    entryIds: [128077],
    definitionIds: [{ id: 132886, specId: 64 }],
  },
  SPLINTERING_SORCERY_TALENT: {
    id: 443739,
    name: 'Splintering Sorcery',
    icon: 'achievement_dungeon_arcanevaults',
    maxRanks: 1,
    entryIds: [117267],
    definitionIds: [{ id: 122279, specId: 64 }],
  },
  SPLINTERSTORM_TALENT: {
    id: 443783,
    name: 'Splinterstorm',
    icon: 'ability_mage_burstofcold',
    maxRanks: 1,
    entryIds: [117257],
    definitionIds: [{ id: 122269, specId: 64 }],
  },
  SPLITTING_ICE_TALENT: {
    id: 56377,
    name: 'Splitting Ice',
    icon: 'spell_frost_ice_shards',
    maxRanks: 1,
    entryIds: [80226],
    definitionIds: [{ id: 85229, specId: 64 }],
  },
  SPONTANEOUS_COMBUSTION_TALENT: {
    id: 451875,
    name: 'Spontaneous Combustion',
    icon: 'ability_mage_worldinflames',
    maxRanks: 2,
    entryIds: [135622],
    definitionIds: [{ id: 140378, specId: 63 }],
  },
  SUMMON_WATER_ELEMENTAL_TALENT: {
    id: 31687,
    name: 'Summon Water Elemental',
    icon: 'spell_frost_summonwaterelemental_2',
    maxRanks: 1,
    entryIds: [134406],
    definitionIds: [{ id: 139178, specId: 64 }],
    manaCost: 7500,
  },
  SUNFURY_EXECUTION_TALENT: {
    id: 449349,
    name: 'Sunfury Execution',
    icon: 'spell_shadow_shadowandflame',
    maxRanks: 1,
    entryIds: [123867],
    definitionIds: [{ id: 128705, specId: 63 }],
  },
  SUPERNOVA_TALENT: {
    id: 157980,
    name: 'Supernova',
    icon: 'spell_mage_supernova',
    maxRanks: 1,
    entryIds: [125818],
    definitionIds: [{ id: 130650, specId: 64 }],
  },
  TEMPORAL_REALIGNMENT_TALENT: {
    id: 1244090,
    name: 'Temporal Realignment',
    icon: 'ability_evoker_timedilation',
    maxRanks: 1,
    entryIds: [134182],
    definitionIds: [{ id: 138962, specId: 64 }],
  },
  THERMAL_CONDITIONING_TALENT: {
    id: 431117,
    name: 'Thermal Conditioning',
    icon: 'spell_fireresistancetotem_01',
    maxRanks: 1,
    entryIds: [117243],
    definitionIds: [{ id: 122255, specId: 64 }],
  },
  THERMAL_VOID_TALENT: {
    id: 1247729,
    name: '热能真空',
    icon: 'spell_mage_thermalvoid',
    maxRanks: 1,
    entryIds: [80248],
    definitionIds: [{ id: 85251, specId: 64 }],
  },
  TIME_MANIPULATION_TALENT: {
    id: 387807,
    name: 'Time Manipulation',
    icon: 'spell_nature_timestop',
    maxRanks: 1,
    entryIds: [80189],
    definitionIds: [{ id: 85192, specId: 64 }],
  },
  TIME_TWIST_TALENT: {
    id: 1255166,
    name: 'Time Twist',
    icon: 'spell_holy_borrowedtime',
    maxRanks: 1,
    entryIds: [135598],
    definitionIds: [{ id: 140354, specId: 63 }],
  },
  TIME_WALK_TALENT: {
    id: 1244087,
    name: 'Time Walk',
    icon: 'warrior_doubletime',
    maxRanks: 1,
    entryIds: [134183],
    definitionIds: [{ id: 138963, specId: 64 }],
  },
  TOME_OF_ANTONIDAS_TALENT: {
    id: 382490,
    name: 'Tome of Antonidas',
    icon: 'inv_misc_book_18',
    maxRanks: 1,
    entryIds: [80155],
    definitionIds: [{ id: 85158, specId: 64 }],
  },
  TOME_OF_RHONIN_TALENT: {
    id: 382493,
    name: 'Tome of Rhonin',
    icon: 'inv_misc_book_04',
    maxRanks: 1,
    entryIds: [80187],
    definitionIds: [{ id: 85190, specId: 64 }],
  },
  TOUCH_OF_THE_ARCHMAGE_1_ARCANE_TALENT: {
    id: 1257942,
    name: 'Touch of the Archmage',
    icon: 'inv12_apextalent_mage_touchofthearchmage',
    maxRanks: 1,
    entryIds: [137028],
    definitionIds: [{ id: 141791, specId: 62 }],
  },
  TOUCH_OF_THE_ARCHMAGE_2_ARCANE_TALENT: {
    id: 1257947,
    name: 'Touch of the Archmage',
    icon: 'spell_holy_arcaneintellect',
    maxRanks: 2,
    entryIds: [137027],
    definitionIds: [{ id: 141790, specId: 62 }],
  },
  TOUCH_OF_THE_ARCHMAGE_3_ARCANE_TALENT: {
    id: 1257950,
    name: 'Touch of the Archmage',
    icon: 'spell_arcane_invocation',
    maxRanks: 1,
    entryIds: [137026],
    definitionIds: [{ id: 141789, specId: 62 }],
  },
  TOUCH_OF_THE_MAGI_TALENT: {
    id: 321507,
    name: 'Touch of the Magi',
    icon: 'inv_ability_mage_radiantspark',
    maxRanks: 1,
    entryIds: [126538],
    definitionIds: [{ id: 131364, specId: 62 }],
    manaCost: 12500,
  },
  WHITE_OUT_TALENT: {
    id: 1281638,
    name: 'White Out',
    icon: 'spell_frost_frostblast',
    maxRanks: 1,
    entryIds: [136880],
    definitionIds: [{ id: 141643, specId: 64 }],
  },
  WILDFIRE_TALENT: {
    id: 1254828,
    name: 'Wildfire',
    icon: 'ability_warlock_inferno',
    maxRanks: 2,
    entryIds: [135613],
    definitionIds: [{ id: 140369, specId: 63 }],
  },
  WINTERS_BLESSING_TALENT: {
    id: 417489,
    name: "Winter's Blessing",
    icon: 'spell_frost_wisp',
    maxRanks: 1,
    entryIds: [134540],
    definitionIds: [{ id: 139308, specId: 64 }],
  },
  WINTERS_PROTECTION_TALENT: {
    id: 382424,
    name: "Winter's Protection",
    icon: 'spell_ice_rune',
    maxRanks: 2,
    entryIds: [80182],
    definitionIds: [{ id: 85185, specId: 64 }],
  },
  WINTERTIDE_TALENT: {
    id: 378406,
    name: 'Wintertide',
    icon: 'ability_deathknight_frozencenter',
    maxRanks: 1,
    entryIds: [80237],
    definitionIds: [{ id: 85240, specId: 64 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_MAGE };
